import { omit } from "lodash";

export function filterHiddenPermissionGroups(permissions) {
  let hiddenPermissionGroups = permissions?.hidden_permission_groups || [];
  if (hiddenPermissionGroups.length) {
    return {
      ...permissions,
      charts_permissions: omit(permissions.charts_permissions, hiddenPermissionGroups),
      admin_permissions: omit(permissions.admin_permissions, hiddenPermissionGroups)
    };
  }

  return permissions;
}

export function extendPermissionByCustom(permissions, orgName) {
  const customPermissions =
    permissions?.custom_permissions?.[orgName]?.["Notifications / Emails / Goals"];

  if (!orgName || !Array.isArray(customPermissions) || customPermissions.length === 0) {
    return permissions;
  }

  const commonPermissions =
    permissions?.notifications_emails_goals?.["Notifications / Emails / Goals"] || [];

  const merged = [...commonPermissions, ...customPermissions];
  return {
    ...omit(permissions, ["custom_permissions"]),
    notifications_emails_goals: {
      ...permissions.notifications_emails_goals,
      "Notifications / Emails / Goals": merged
    }
  };
}

export const rearrangeDailyEmailsPermissions = (allPermissions) => {
  if (allPermissions) {
    // Separate daily email permissions comes last in the list, but in ui in should come after Daily Email
    let daily = [];
    let rest = [];

    const EMAILS_KEY = "Notifications / Emails / Goals";

    let { notifications_emails_goals: { [EMAILS_KEY]: emails = [] } = {} } = allPermissions;
    let dailyEmails = ["Daily Email", "Separate emails for each location"];

    for (let perm of emails) {
      dailyEmails.includes(perm.name) ? daily.push(perm) : rest.push(perm);
    }

    return {
      permissions: {
        ...allPermissions,
        notifications_emails_goals: {
          ...allPermissions.notifications_emails_goals,
          [EMAILS_KEY]: [...daily, ...rest]
        }
      },
      daily
    };
  }

  return {};
};
